module.exports = function getResource(label, vars = []) {
    let resources = {
        please: 'Please',
        signIn: 'sign in',
        toViewThisPage: 'to view this page.'
    };
    return resources[label];
};
